import { render, staticRenderFns } from "./custom-types.vue?vue&type=template&id=4af549fa"
import script from "./custom-types.vue?vue&type=script&lang=js"
export * from "./custom-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports